import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { extractErrorMessage } from '../../utils/extractErrorMessage'
import { useDeleteLuckyDraw } from '../../api/lucky-draw'

const Delete = ({ openDelete, data, onClose, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteLuckyDraw()
  const { enqueueSnackbar } = useSnackbar()

  const handleDelete = async () => {
    try {
      await mutateAsync({ id: data.id })
      enqueueSnackbar('Successfully removed.', { variant: 'success' })
      onClose()
      refetch()
    } catch (e) {
      enqueueSnackbar(extractErrorMessage(e), { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to delete <b>{data.name}</b>? This action cannot be undone.
        </Typography>
        {data.winnerCount > 0 && (
          <Typography color='error' mt={2}>
            {data.winnerCount} recorded winner{data.winnerCount === 1 ? '' : 's'} will be deleted
            with it.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant='contained'
          style={{ background: 'red', color: 'white' }}
          onClick={handleDelete}
          disabled={isLoading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
